import { render, staticRenderFns } from "./AddGLTransaction.vue?vue&type=template&id=6ca377e8"
import script from "./AddGLTransaction.vue?vue&type=script&lang=js"
export * from "./AddGLTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports